import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-overflow-before></div>\n<div>{{yield}}</div>\n")